export default __webpack_public_path__ + "static/media/outside.da6fe593.JPG";